// extracted by mini-css-extract-plugin
var _1 = "VIDBKi06KPSih5Te8jEw";
export { _1 as "searchContainer" }
